import React, { PropTypes, Component } from 'react';

import SubscribeForm from 'components/Forms/Subscribe';
import 'styles/conclusion.scss';

class Conclusion extends Component {
    render () {
        return (
            <div className="section conclusion">
              <div className="container">
                <div className="header">
                  <h2>Stay in Touch</h2>
                </div>
                <div className="body">
                  <p>
                    I strive to provide a safe, trusting, nonjudgmental, and
                    respectful environment in which clients are able to work through
                    their difficult issues.  My goal is to help clients develop
                    insights and perspective that will help them cope with
                    life’s challenges more effectively.
                  </p>

                  <div className="form">
                    <div className="form-header">
                      <p>
                        Contact me today for a free consultation
                      </p>
                    </div>
                    <div className="form-body">
                      <div>
                        <SubscribeForm />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        );
    }
}

export default Conclusion;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Conclusion.js
 **/